import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';

class InsightsState {
  store = new DomainStore();
  emojiReady;

  inboxSummary;
  ptoSummary;
  newHireSummary;
  jobApplicantSummary;

  constructor() {
    makeAutoObservable(this, {
      store: false,
      emojiReady: false
    });
  }

  receiveProps({inboxSummary, newHireSummary, ptoSummary, jobApplicantSummary, emojiReady}) {
    this.inboxSummary = inboxSummary;
    this.newHireSummary = newHireSummary;
    this.ptoSummary = ptoSummary;
    this.jobApplicantSummary = jobApplicantSummary;
    this.emojiReady = emojiReady;
  }

  get hasNoInsights() {
    return this.inboxSummary.itemsCount === 0 &&
      this.newHireSummary.newHireCount === 0 &&
      this.ptoSummary.requestsCount === 0 &&
      this.jobApplicantSummary.applicantCount === 0 &&
      this.jobApplicantSummary.staleApplicantCount === 0;
  }
}

export default InsightsState;
